import React from "react";

/// React router dom
import { Routes, Route } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

import ScrollToTop from "./layouts/ScrollToTop";
import Home from "./components/Dashboard/Home";
import ProjectDetails from "./projects/projectdetails";

/// Pages
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import UserList from "./users/userlist";
import AddUser from "./users/adduser";
import EditUser from "./users/edituser";
import ProjectList from "./projects/projectlist";
import ProjectDashboard from "./projects/projectDashboard";
import AddProject from "./projects/addproject";
import EditProject from "./projects/editproject";
import TaskList from "./tasks/tasklist";
import ProjectTaskList from "./tasks/projectTaskList";
import AddTask from "./tasks/addtask";
import EditTask from "./tasks/edittask";
import Modules from "./modules/modules";
import Subscription from "./components/AppsMenu/AppProfile/subscription";
import TaskBoard from "./tasks/taskboard";
import TaskDetails from "./tasks/taskdetails";
import PrivateRoutes from '../PrivateRoutes';
import BusinessDashboard from './pages/BusinessDashboard';
import Login from './pages/Login';
import Registration from './pages/Registration';
import HomeLanding from "./pages/HomeLanding";
import AboutSystem from "./pages/AboutSystem";
import Products from "./pages/Products";
import ProductsTask from "./pages/ProductsTask";
import ProductsDocuments from "./pages/ProductsDocuments";
import ProductsCredentialVault from "./pages/ProductsCredentialVault";
import ProductsProjects from "./pages/ProductsProjects";
import ProductsForum from "./pages/ProductsForum";
import ProductsSnapBill from "./pages/ProductsSnapBill";
import SubscriptionPackages from "./pages/SubscriptionPackages";
import ContactUs from "./pages/ContactUs";
import PublicNavbar from "./layouts/PublicNavbar";
import HomeFooter from "./components/home/HomeFooter";
import EditProfilePage from "./layouts/nav/EditProfilePage";
import UserSubscription from "./pages/UserSubscription";
import TermsAndConditions from "./pages/terms";
import PrivacyPolicy from "./pages/Privacy";
import RefundCancellationPolicy from "./pages/RefundCancellationPolicy";
import RootRoute from "./components/RootRoute";

import ChangePassword from './users/changePassword';
import AddBranch from './settings/addBranch';
import EditBranch from './settings/editBranch';
import AddDepartment from './settings/addDepartment';
import EditDepartment from './settings/editDepartment';
import AddDesignation from './settings/addDesignation.js';
import DesignationList from "./settings/designationList.js";
import AddStaff from './staff/addStaff.js';
import StaffList from './staff/staffList.js';
import EditStaff from './staff/editStaff.js';
import StaffDetails from './staff/staffDetails.js';
import StaffAddressForm from './staff/StaffAddressForm.js';
import StaffContactForm from './staff/StaffContactForm.js';
import StaffEmploymentForm from './staff/StaffEmploymentForm.js';
import StaffDocumentForm from './staff/StaffDocumentForm.js';

import ForgotPassword from './pages/SendResetLink';
import ResetPassword from './pages/ResetPassword';
import RegistrationSubscriptionPlans from './pages/RegistrationSubscriptionPlans';
import TestSubscriptionPlans from './pages/TestSubscriptionPlans';
import Worksheet from "./tasks/worksheet";
import ForumList from "./forum/forumList";
import ForumDashboard from "./forum/forumDashboard";
import LaunchInvoiceScanner from "./invoiceScanner/LaunchInvoiceScanner";
import SnapBillSettings from "./invoiceScanner/SnapBillSettings";
import ModuleLogout from "./moduleLogout/ModuleLogout";
import ModuleSessionCallback from "./moduleSession/ModuleSessionCallback";
import ForumCreate from "./forum/forumCreate";
import ForumEdit from "./forum/forumEdit";
import ForumDetail from "./forum/forumDetail";
import ForumTransactionStatementList from "./forum/ForumTransactionStatementList";
import PerformanceDashboard from "./tasks/performanceDashboard";
import PerformanceDetails from "./tasks/performanceDetails";
import BranchList from "./settings/listbranch";
import DepartmentList from "./settings/listdepartments";
import AddSubDepartment from "./settings/addSubDepartment";
import EditSubDepartment from "./settings/editSubDepartment";
import SubDepartmentList from "./settings/subDepartmentList";
import AccessControl from "./settings/accessControl";
import FlowdoRoleList from "./settings/flowdoRoleList";
import FlowdoRoleForm from "./settings/flowdoRoleForm";
import SettingsLanding from "./settings/SettingsLanding";

import CredentialVaultList from './credentialVault/credentialVaultList';
import PersonalVaultList from './credentialVault/personalVaultList';
import CredentialVaultForm from './credentialVault/credentialVaultForm';
import CredentialVaultDetail from './credentialVault/credentialVaultDetail';

//vehicle
import AddVehicle from "./vehicle/addVehicle";
import VehicleList from "./vehicle/vehicleList";
import EditVehicle from "./vehicle/editVehicle";
import VehicleDetails from "./vehicle/vehicleDetails";
import VehicleDocumentForm from "./vehicle/VehicleDocumentForm";
import VehicleInsuranceForm from "./vehicle/VehicleInsuranceForm";
import VehicleRegistrationForm from "./vehicle/VehicleRegistrationForm";

import DocumentList from "./Documents/documentList";
import AddDocumentCategory from "./Documents/AddDocumentCatagory.js";
import DocumentCategoryList from "./Documents/DocumentCatagoryList.js";
import DocumentsDashboard from "./Documents/recentDocuments";
import DocumentDetails from "./Documents/documentDetails.js";
import SharedDocuments from "./Documents/sharedDocuments.js";
import FavoriteDocuments from "./Documents/favoriteDocuments.js";
import SharedDocumentViewer from "./Documents/SharedDocumentViewer.js";
import AddDocument from "./Documents/AddDocument.js";
import EditDocument from "./Documents/EditDocument.js";
import StaffDocumentDetails from "./staff/StaffDocumentDetails.js";
import VehicleDocumentDetails from "./vehicle/VehicleDocumentDetails.js";
import SubscriptionFeatureRequired from "./pages/SubscriptionFeatureRequired.js";
import SubscriptionPaymentResult from "./pages/SubscriptionPaymentResult.js";
import SubscriptionPaymentSuccess from "./pages/SubscriptionPaymentSuccess.js";
import TaskDailyUpdatesList from "./tasks/TaskDailyUpdatesList.js";
import SubscriptionCheckout from "./pages/SubscriptionCheckout.js";
import SubscriptionRenewal from "./pages/SubscriptionRenewal.js";
import VaultSettings from "./credentialVault/vaultSettings.jsx";
import WorkRegisterList from "./workRegister/workRegisterList.js";
import WorkRegisterTeam from "./workRegister/workRegisterTeam.js";
import CreditWalletPage from "./pages/CreditWalletPage.jsx";
import CreditPurchaseHistoryPage from "./pages/CreditPurchaseHistoryPage.jsx";
import CreditPurchaseDetailPage from "./pages/CreditPurchaseDetailPage.jsx";
import CreditCheckout from "./pages/CreditCheckout.jsx";
import NotificationsPage from "./pages/NotificationsPage";

const PublicLayout = ({ children }) => (
  <>
    <PublicNavbar />
    <div className="public-page-shell">
      {children}
      <HomeFooter />
    </div>
  </>
);

const Markup = () => {

  const allroutes = [
    //dashboard
    { url: '/dashboard', component: <BusinessDashboard /> },
    { url: '/home', component: <Home /> },
    //users / settings hub
    { url: '/settings', component: <SettingsLanding /> },
    { url: '/settings/userlist', component: <UserList /> },
    { url: '/settings/adduser', component: <AddUser /> },
    { url: '/settings/edituser', component: <EditUser /> },
    { url: '/credits', component: <CreditWalletPage /> },
    { url: '/credits/purchases', component: <CreditPurchaseHistoryPage /> },
    { url: '/credits/purchases/:purchaseId', component: <CreditPurchaseDetailPage /> },
    { url: '/credits/checkout', component: <CreditCheckout /> },
    { url: '/notifications', component: <NotificationsPage /> },

    //staff
    { url: '/staff/staffList', component: <StaffList /> },
    { url: '/staff/addStaff', component: <AddStaff /> },
    { url: '/staff/editStaff/:id', component: <EditStaff /> },
    { url: '/staff/staffDetails/:id', component: <StaffDetails /> },
    { url: '/staff/:staffId/address/add', component: <StaffAddressForm /> },
    { url: '/staff/:staffId/address/:addressId/edit', component: <StaffAddressForm /> },
    { url: '/staff/:staffId/contact/add', component: <StaffContactForm /> },
    { url: '/staff/:staffId/contact/:contactId/edit', component: <StaffContactForm /> },
    { url: '/staff/:staffId/employment/add', component: <StaffEmploymentForm /> },
    { url: '/staff/:staffId/employment/:employmentId/edit', component: <StaffEmploymentForm /> },
    { url: '/staff/:staffId/document/add', component: <StaffDocumentForm /> },
    { url: '/staff/:staffId/document/:documentId/edit', component: <StaffDocumentForm /> },
    { url: '/staff/:staffId/document/:documentId', component: <StaffDocumentDetails /> },

    //projects
    { url: '/task/projectlist', component: <ProjectList /> },
    { url: '/task/projectdashboard', component: <ProjectDashboard /> },
    { url: '/task/projecttasklist', component: <ProjectTaskList /> },
    { url: '/task/addproject', component: <AddProject /> },
    { url: '/task/editproject', component: <EditProject /> },
    { url: '/task/projectdetails/:projectId', component: <ProjectDetails /> },
    { url: '/task/worksheet', component: <Worksheet /> },
    { url: '/forum/dashboard', component: <ForumDashboard /> },
    { url: '/forum/list', component: <ForumList /> },
    { url: '/forum/create', component: <ForumCreate /> },
    { url: '/forum/edit/:id', component: <ForumEdit /> },
    { url: '/forum/detail/:id/daily-updates', component: <ForumTransactionStatementList /> },
    { url: '/forum/detail/:id', component: <ForumDetail /> },
    { url: '/invoice-scanner/launch', component: <LaunchInvoiceScanner /> },
    { url: '/task/performance', component: <PerformanceDashboard /> },
    { url: '/task/performance/details', component: <PerformanceDetails /> },
    { url: '/subscription-feature-required', component: <SubscriptionFeatureRequired /> },
    { url: '/task/taskdetails/:taskid/daily-updates', component: <TaskDailyUpdatesList /> },
    { url: '/task/projectdetails/:projectId/daily-updates', component: <TaskDailyUpdatesList /> },


    //tasks
    { url: '/task/tasklist', component: <TaskList /> },
    { url: '/task/addtask', component: <AddTask /> },
    { url: '/task/edittask', component: <EditTask /> },
    { url: '/taskboard', component: <TaskBoard /> },
    { url: '/work-register/list', component: <WorkRegisterList /> },
    { url: '/work-register/team', component: <WorkRegisterTeam /> },

    { url: '/modules', component: <Modules /> },
    { url: '/subscribe', component: <Subscription /> },
    { url: '/task/taskdetails/:taskid', component: <TaskDetails /> },
    { url: '/user-subscription', component: <UserSubscription /> },
    { url: '/subscription/payment-result', component: <SubscriptionPaymentResult /> },
    { url: '/subscription/payment-success', component: <SubscriptionPaymentSuccess /> },
    { url: '/changePassword', component: <ChangePassword /> },
    { url: 'settings/addBranch', component: <AddBranch /> },
    { url: 'settings/editBranch/:id', component: <EditBranch /> },
    { url: 'settings/addDepartment', component: <AddDepartment /> },
    { url: 'settings/editDepartment/:id', component: <EditDepartment /> },
    { url: 'settings/branchList', component: <BranchList /> },
    { url: 'settings/departmentList', component: <DepartmentList /> },
    { url: 'settings/accessControl', component: <AccessControl /> },
    { url: 'settings/flowdoRoles', component: <FlowdoRoleList /> },
    { url: 'settings/flowdoRoles/new', component: <FlowdoRoleForm /> },
    { url: 'settings/flowdoRoles/:id', component: <FlowdoRoleForm /> },
    { url: 'settings/snapBill', component: <SnapBillSettings /> },
    { url: 'settings/addSubDepartment', component: <AddSubDepartment /> },
    { url: 'settings/editSubDepartment/:id', component: <EditSubDepartment /> },
    { url: 'settings/subDepartmentList', component: <SubDepartmentList /> },
    { url: 'settings/addDesignation', component: <AddDesignation /> },
    { url: 'settings/designationList', component: <DesignationList /> },
    { url: 'subscription/checkout', component: <SubscriptionCheckout /> },
    { url: 'subscription/renew', component: <SubscriptionRenewal /> },

    { url: 'credential-vault/credentialVaultList', component: <CredentialVaultList /> },
    { url: 'credential-vault/personalVaultList', component: <PersonalVaultList /> },
    { url: 'credential-vault/credentialDetail/:id', component: <CredentialVaultDetail /> },
    { url: 'credential-vault/addCredential', component: <CredentialVaultForm /> },
    { url: 'credential-vault/editCredential/:id', component: <CredentialVaultForm /> },
    { url: 'credential-vault/vaultSettings', component: <VaultSettings /> },

    //Vehicle
    { url: 'vehicle/addVehicle', component: <AddVehicle /> },
    { url: 'vehicle/vehicleList', component: <VehicleList /> },
    { url: 'vehicle/editVehicle/:id', component: <EditVehicle /> },
    { url: 'vehicle/vehicleDetails/:id', component: <VehicleDetails /> },
    { url: 'vehicle/:vehicleId/document/add', component: <VehicleDocumentForm /> },
    { url: 'vehicle/:vehicleId/document/:documentId/edit', component: <VehicleDocumentForm /> },
    { url: 'vehicle/:vehicleId/insurance/add', component: <VehicleInsuranceForm /> },
    { url: 'vehicle/:vehicleId/insurance/:insuranceId/edit', component: <VehicleInsuranceForm /> },
    { url: 'vehicle/:vehicleId/registration/add', component: <VehicleRegistrationForm /> },
    { url: 'vehicle/:vehicleId/registration/:registrationId/edit', component: <VehicleRegistrationForm /> },
    { url: 'vehicle/:vehicleId/document/:documentId', component: <VehicleDocumentDetails /> },

    //Document
    { url: 'documents/mydocuments', component: <DocumentList /> },
    { url: 'documents/folder/:folderId', component: <DocumentList /> },
    { url: 'documents/dashboard', component: <DocumentsDashboard /> },
    { url: 'documents/addDocumentClassification', component: <AddDocumentCategory /> },
    { url: 'documents/editDocumentClassification/:id', component: <AddDocumentCategory /> },
    { url: 'documents/documentClassifications', component: <DocumentCategoryList /> },
    { url: 'documents/details/:documentId', component: <DocumentDetails /> },
    { url: 'documents/shared', component: <SharedDocuments /> },
    { url: 'documents/favorites', component: <FavoriteDocuments /> },
    { url: 'documents/upload', component: <AddDocument /> },
    { url: 'documents/edit/:documentId', component: <EditDocument /> },
  ]

  //let path = window.location.pathname;
  //path = path.split("/");
  //path = path[path.length - 1];

  //let pagePath = path.split("-").includes("page");
  //const { menuToggle } = useContext(ThemeContext);

  return (
    <>
      <Routes>
        {/* Root route with authentication check */}
        <Route path="/" element={<RootRoute />} />
        <Route path="/about-us" element={<PublicLayout><AboutSystem /></PublicLayout>} />
        <Route path="/products" element={<PublicLayout><Products /></PublicLayout>} />
        <Route path="/products/task" element={<PublicLayout><ProductsTask /></PublicLayout>} />
        <Route path="/products/documents" element={<PublicLayout><ProductsDocuments /></PublicLayout>} />
        <Route path="/products/credentials-vault" element={<PublicLayout><ProductsCredentialVault /></PublicLayout>} />
        <Route path="/products/projects" element={<PublicLayout><ProductsProjects /></PublicLayout>} />
        <Route path="/products/discussion-forum" element={<PublicLayout><ProductsForum /></PublicLayout>} />
        <Route path="/products/snap-bill" element={<PublicLayout><ProductsSnapBill /></PublicLayout>} />
        <Route path="/pricing" element={<PublicLayout><SubscriptionPackages /></PublicLayout>} />
        <Route path="/contact-us" element={<PublicLayout><ContactUs /></PublicLayout>} />
        <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
        <Route path="/auth/module-session" element={<PublicLayout><ModuleSessionCallback /></PublicLayout>} />
        <Route path="/module-logout" element={<PublicLayout><ModuleLogout /></PublicLayout>} />
        <Route path="/register" element={<PublicLayout><Registration /></PublicLayout>} />
        <Route path="/terms-and-conditions" element={<PublicLayout><TermsAndConditions /></PublicLayout>} />
        <Route path="/refund-cancellation-policy" element={<PublicLayout><RefundCancellationPolicy /></PublicLayout>} />
        <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
        <Route path='/forgot-password' element={<PublicLayout><ForgotPassword /></PublicLayout>} />
        <Route path='/reset-password' element={<PublicLayout><ResetPassword /></PublicLayout>} />
        <Route path='/registration-subscription' element={<PublicLayout><RegistrationSubscriptionPlans /></PublicLayout>} />
        <Route path='/test-subscription' element={<PublicLayout><TestSubscriptionPlans /></PublicLayout>} />
        <Route path='/shared' element={<PublicLayout><SharedDocumentViewer /></PublicLayout>} />
        {/* Private routes */}
        <Route path='page-lock-screen' element={<LockScreen />} />
        <Route path='page-error-400' element={<Error400 />} />
        <Route path='page-error-403' element={<Error403 />} />
        <Route path='page-error-404' element={<Error404 />} />
        <Route path='page-error-500' element={<Error500 />} />
        <Route path='page-error-503' element={<Error503 />} />
        {/* Pathless layout: PrivateRoutes only mounts when a child path matches.
            Keep /dashboard in allroutes or the shell (nav/sidebar) never renders. */}
        <Route element={<PrivateRoutes />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
          <Route path="edit-profile" element={<EditProfilePage />} />
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

export default Markup;